import getContentFromElementById from './getContentFromElementById';
export default function copyContentFromElementByIdIntoClipboard(id) {
    navigator.clipboard.writeText(getContentFromElementById(id)).then(() => {
        // console.log('Copied text to clipboard')
    }).catch(err => {
        console.error('Failed to copy text: ', err);
    });
}
